export { default } from './TabList';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TabList/index.js
// module id = 892
// module chunks = 2